import React from "react";

import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import InputText from "commons/ui/input/InputText";
import LineSeparator from "commons/ui/LineSeparator";

import ExtensionsProporsionInfo from "components/subComponents/ExtensionsProporsionInfo";
import TwoLanguagesAdornment from "components/subComponents/TwoLanguagesAdornment";
import AttachmentPicker from "components/ui/AttachmentPicker";
import TitleFunctionsTopBlock from "components/ui/TitleFunctionsTopBlock";

import useCheckSectionErrors from "hooks/form/blocks/useCheckSectionErrors";
import useSectionProductFooter from "hooks/form/blocks/useSectionProductFooter";
import useTitleFunctionsTopBlock from "hooks/useTitleFunctionsTopBlock";

import { DesktopOrMobile } from "types/enums";

function SectionProductFooterForm() {
    const { buttonDelete, setImageOne, setImageTwo, setImageThree, formHook } =
        useSectionProductFooter();

    useCheckSectionErrors({ formHook });

    const { checkErrorVisibility, setValue, form } = formHook;

    const titleFunctionsTopBlockHook = useTitleFunctionsTopBlock({
        buttonDelete: buttonDelete,
    });

    return (
        <>
            <TitleFunctionsTopBlock titleFunctionsTopBlockHook={titleFunctionsTopBlockHook} />

            {titleFunctionsTopBlockHook.closedBlock && (
                <>
                    <GridColumn>
                        <ExtensionsProporsionInfo
                            desktopText={"1000x1500px oppure 1000x1000px (max 400KB)"}
                            mobileText={"667x1000px oppure 667x667px (max 250KB)"}
                            proportion={"quadrata o verticale"}
                        />

                        <GridItem className={"col-xs-12-12"}>
                            <GridRow>
                                <div className={"col-xxl-12-6 col-xl-12-12 col-xs-12-12"}>
                                    <GridRow>
                                        <GridItem>
                                            <h3>Immagine a sinistra</h3>
                                        </GridItem>
                                    </GridRow>

                                    <GridRow>
                                        <GridItem className={"col-xs-24-12"}>
                                            <AttachmentPicker
                                                buttonLabel={"Foto Desktop"}
                                                setFile={(file) =>
                                                    setImageOne(file, DesktopOrMobile.desktop)
                                                }
                                                file={form.img_one.desktop}
                                                accept={".png,.jpg,.jpeg"}
                                                errors={checkErrorVisibility("img_one.desktop")}
                                            />
                                        </GridItem>

                                        <GridItem className={"col-xs-24-12"}>
                                            <AttachmentPicker
                                                buttonLabel={"Foto Mobile"}
                                                setFile={(file) =>
                                                    setImageOne(file, DesktopOrMobile.mobile)
                                                }
                                                file={form.img_one.mobile}
                                                accept={".png,.jpg,.jpeg"}
                                                errors={checkErrorVisibility("img_one.mobile")}
                                            />
                                        </GridItem>
                                    </GridRow>
                                </div>

                                <div className={"col-xxl-12-6 col-xl-12-12 col-xs-12-12"}>
                                    <GridRow>
                                        <GridItem>
                                            <h3>Immagine al centro</h3>
                                        </GridItem>
                                    </GridRow>

                                    <GridRow>
                                        <GridItem className={"col-xs-24-12"}>
                                            <AttachmentPicker
                                                buttonLabel={"Foto Desktop"}
                                                setFile={(file) =>
                                                    setImageTwo(file, DesktopOrMobile.desktop)
                                                }
                                                file={form.img_two.desktop}
                                                accept={".png,.jpg,.jpeg"}
                                                errors={checkErrorVisibility("img_two.desktop")}
                                            />
                                        </GridItem>

                                        <GridItem className={"col-xs-24-12"}>
                                            <AttachmentPicker
                                                buttonLabel={"Foto Mobile"}
                                                setFile={(file) =>
                                                    setImageTwo(file, DesktopOrMobile.mobile)
                                                }
                                                file={form.img_two.mobile}
                                                accept={".png,.jpg,.jpeg"}
                                                errors={checkErrorVisibility("img_two.mobile")}
                                            />
                                        </GridItem>
                                    </GridRow>
                                </div>
                            </GridRow>
                        </GridItem>

                        <GridRow>
                            <div className={"col-xs-12-12"}>
                                <GridRow>
                                    <GridItem>
                                        <h3>Immagine a destra</h3>
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xxl-12-3 col-xl-12-6 col-xs-12-6"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Desktop"}
                                            setFile={(file) =>
                                                setImageThree(file, DesktopOrMobile.desktop)
                                            }
                                            file={form.img_three.desktop}
                                            accept={".png,.jpg,.jpeg"}
                                            errors={checkErrorVisibility("img_three.desktop")}
                                        />
                                    </GridItem>

                                    <GridItem className={"col-xxl-12-3 col-xl-12-6 col-xs-12-6"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Mobile"}
                                            setFile={(file) =>
                                                setImageThree(file, DesktopOrMobile.mobile)
                                            }
                                            file={form.img_three.mobile}
                                            accept={".png,.jpg,.jpeg"}
                                            errors={checkErrorVisibility("img_three.mobile")}
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>
                        </GridRow>
                    </GridColumn>

                    <LineSeparator />

                    <GridColumn>
                        <GridRow>
                            <GridItem className={"col-xs-12-12"}>
                                <h3>Testi</h3>
                            </GridItem>
                        </GridRow>

                        <GridRow>
                            <GridItem>
                                <span>Inserisci i testi per tutte le lingue</span>
                            </GridItem>
                        </GridRow>
                    </GridColumn>

                    <GridColumn>
                        <GridRow>
                            <div className={"col-xs-12-6"}>
                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Titolo a sinistra"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.text_1}
                                            setValue={setValue}
                                            path={"text.it.text_1"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Testo a sinistra"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.text_2}
                                            setValue={setValue}
                                            path={"text.it.text_2"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Testo bottone a sinistra"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.text_4}
                                            setValue={setValue}
                                            path={"text.it.text_4"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Url bottone a sinistra"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.text_3}
                                            setValue={setValue}
                                            path={"text.it.text_3"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>

                            <div className={"col-xs-12-6"}>
                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Titolo a sinistra"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.text_1}
                                            setValue={setValue}
                                            path={"text.en.text_1"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Testo a sinistra"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.text_2}
                                            setValue={setValue}
                                            path={"text.en.text_2"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Testo bottone a sinistra"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.text_4}
                                            setValue={setValue}
                                            path={"text.en.text_4"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Url bottone a sinistra"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.text_3}
                                            setValue={setValue}
                                            path={"text.en.text_3"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>
                        </GridRow>
                    </GridColumn>

                    <GridColumn>
                        <GridRow>
                            <div className={"col-xs-12-6"}>
                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Titolo al centro"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.text_5}
                                            setValue={setValue}
                                            path={"text.it.text_5"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Testo al centro"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.text_6}
                                            setValue={setValue}
                                            path={"text.it.text_6"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Testo bottone al centro"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.text_8}
                                            setValue={setValue}
                                            path={"text.it.text_8"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Url bottone al centro"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.text_7}
                                            setValue={setValue}
                                            path={"text.it.text_7"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>

                            <div className={"col-xs-12-6"}>
                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Titolo al centro"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.text_5}
                                            setValue={setValue}
                                            path={"text.en.text_5"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Testo al centro"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.text_6}
                                            setValue={setValue}
                                            path={"text.en.text_6"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Testo bottone al centro"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.text_8}
                                            setValue={setValue}
                                            path={"text.en.text_8"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Url bottone al centro"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.text_7}
                                            setValue={setValue}
                                            path={"text.en.text_7"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>
                        </GridRow>
                    </GridColumn>

                    <GridColumn>
                        <GridRow>
                            <div className={"col-xs-12-6"}>
                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Titolo a destra"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.text_9}
                                            setValue={setValue}
                                            path={"text.it.text_9"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Testo a destra"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.text_10}
                                            setValue={setValue}
                                            path={"text.it.text_10"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Testo bottone a destra"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.text_12}
                                            setValue={setValue}
                                            path={"text.it.text_12"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Url bottone a destra"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.text_11}
                                            setValue={setValue}
                                            path={"text.it.text_11"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>

                            <div className={"col-xs-12-6"}>
                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Titolo a destra"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.text_9}
                                            setValue={setValue}
                                            path={"text.en.text_9"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Testo a destra"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.text_10}
                                            setValue={setValue}
                                            path={"text.en.text_10"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Testo bottone a destra"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.text_12}
                                            setValue={setValue}
                                            path={"text.en.text_12"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Url bottone a destra"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.text_11}
                                            setValue={setValue}
                                            path={"text.en.text_11"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>
                        </GridRow>
                    </GridColumn>
                </>
            )}
        </>
    );
}

export default SectionProductFooterForm;
